<template>
  <div v-show="$route.path != '/login'">
    <b-sidebar
      id="sidebar-1"
      title="Sidebar"
      shadow
      no-header
      bg-variant="dark"
      backdrop
      backdrop-variant="dark"
      text-variant="light"
    >
      <template v-slot:default="{ hide }">
        <div class="p-3 d-flex justify-content-between">
          <b-button block @click="hide"><b-icon icon="x"></b-icon></b-button>
        </div>
        <div class="p-3">
          <nav class="mb-3">
            <b-nav vertical>
              <b-nav-item active @click="hide" v-for="(item, index) in navLinks" :key="index"
                ><router-link class="routerlink" :to="item.path"
                  >{{ item.name }}</router-link
                ></b-nav-item
              >
            </b-nav>
          </nav>
        </div>
      </template>
    </b-sidebar>
  </div>
</template>
<script>
import UserService from '../services/users'

export default {
  name: "SidebarComponent",
  data() {
    return {
      navLinks: [
        { path: "/dashboard", name: "Dashboard", restrict: false },
        { path: "/users", name: "Usuários", restrict: true },
        { path: "/branches", name: "Unidades", restrict: false },
        { path: "/indicator-groups", name: "Grupo de Indicadores", restrict: false },
        { path: "/indicators", name: "Indicadores", restrict: false }
      ],
      isAdmin: false,
    };
  },
  mounted() {
    UserService.me()
      .then((response) => {
        const role = response.role

        this.isAdmin = (role == 'admin')

        if (this.isAdmin == false) {
          this.navLinks = this.navLinks.filter(item => item.restrict == false)
        }
      })
  }
};
</script>

<style>
.routerlink {
  color: white !important;
  text-decoration: none;
  cursor: pointer;
}
</style>
